import React from "react";
import { Container, Row, Col, Table } from "react-bootstrap";
import CustomButton from "../../common-components/button/Button.jsx";
import { useDispatch, useSelector } from "react-redux";
import { convertMySQLDBToMongoDB, convertMySQLToMongoDB } from "../../state/reducers/databaseConversion.js";
import { updateLoadingMessage } from "../../state/reducers/common.js";
import loadingMessages from "../../common/loadingMessages.js";

function DBSummary({resetConversion}) {
  const dispatch = useDispatch();
  const entireState = useSelector(state => state);
  console.log("Entire state in DBSummary:", entireState);

  const databaseConversionState = useSelector(state => state.databaseConversion);
  console.log("Database Conversion State:", databaseConversionState);

  const mergedPayload = useSelector(state => state.databaseConversion.mergedPayload);
  const selectionType = useSelector(state => state.databaseConversion.selectionType);
  const sourcePayload = useSelector(state => state.databaseConversion.sourcePayload);
  const targetPayload = useSelector(state => state.databaseConversion.targetPayload);

  // Try to get data from various possible locations
  const sourceDatabaseDetails = sourcePayload?.mysql_details || mergedPayload?.mysql_details || {};
  const targetDatabaseDetails = targetPayload?.mongodb_details || mergedPayload?.mongodb_details || {};

  const selectedTables = targetDatabaseDetails?.properties?.collections || [];
  const totalObjects = selectedTables.length;

  const handleStartConversion = () => {
    if (selectionType === "all") {
      dispatch(updateLoadingMessage({
        message: loadingMessages.common
      }))
      dispatch(convertMySQLDBToMongoDB(mergedPayload));
    } else if (selectionType === "selected") {
      dispatch(updateLoadingMessage({
        message: loadingMessages.common
      }))
      dispatch(convertMySQLToMongoDB(mergedPayload));
    }
  };

  return (
    <div className="page-wrapper database-conversion-page px-3">
      <Container>
        <Row>
          <Col>
            <h2 className="page-title">Summary</h2>
          </Col>
        </Row>
        <Row className="mb-4">
          <Col md={6}>
            <Table bordered>
              <thead>
                <tr>
                  <th colSpan="2">Source Database</th>
                  <th>{sourceDatabaseDetails?.name || "MySQL"}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Host</td>
                  <td colSpan="2">{sourceDatabaseDetails?.properties?.host}</td>
                </tr>
                <tr>
                  <td>Username</td>
                  <td colSpan="2">{sourceDatabaseDetails?.properties?.username}</td>
                </tr>
                <tr>
                  <td>Port</td>
                  <td colSpan="2">{sourceDatabaseDetails?.properties?.port}</td>
                </tr>
                <tr>
                  <td>Database</td>
                  <td colSpan="2">{sourceDatabaseDetails?.properties?.database}</td>
                </tr>
              </tbody>
            </Table>
          </Col>
          <Col md={6}>
            <Table bordered>
              <thead>
                <tr>
                  <th colSpan="2">Target Database</th>
                  <th>{targetDatabaseDetails?.name || "MongoDB"}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Host</td>
                  <td colSpan="2">{targetDatabaseDetails?.properties?.host}</td>
                </tr>
                <tr>
                  <td>Port</td>
                  <td colSpan="2">{targetDatabaseDetails?.properties?.port}</td>
                </tr>
                <tr>
                  <td>Database</td>
                  <td colSpan="2">{targetDatabaseDetails?.properties?.database}</td>
                </tr>
              </tbody>
            </Table>
          </Col>
        </Row>
        <Row className="mb-4">
          <Col md={6}>
            <h3>Selected objects info</h3>
            <p>Total {totalObjects} Objects</p>
            <p style={{marginLeft: "20px"}}>Tables: {totalObjects}</p>
          </Col>
        </Row>
        <Row>
          <Col className="text-end">
            <CustomButton className="next-btn resetButton" label="Reset" onClick={resetConversion} />
            <CustomButton className="next-btn" label="Start Conversion" onClick={handleStartConversion} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default DBSummary;